export default __webpack_public_path__ + "static/media/BG_Login.1c06cd93.svg";